import React from 'react';
import moment from 'moment-timezone';
import { getTimezoneForNetwork } from 'AppSrc/core/utility-functions/date-functions';
import PropTypes from 'prop-types';
import { summarySummaryVFDatePickerFieldData } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import 'AppSrc/core/style/components/form/form-base-components/summary-components/summary-v-f-date-picker.css';

const SummaryVFDatePicker = React.memo(({
  fieldData,
  selectedNetwork,
}) => {

  const {
    fieldTitle,
    displayValues,
  } = fieldData;
  // display values is a date string.
  // currently used for start and end date which are mandatory
  // but allow the component to handle a blank or null value for future cases

  // make sure date time is displayed in the correct timezone for the network
  const timezone = getTimezoneForNetwork(selectedNetwork);
  const valueMoment = displayValues ? moment.tz(displayValues, timezone) : null;
  const displayDate = valueMoment ? valueMoment.format('DD/MM/YYYY') : '-';
  const time = valueMoment ? valueMoment.format('HH:mm') : '';
  const timeZone = valueMoment ? valueMoment.format('z') : null;
  const displayTime = time && timeZone ? `${time} (${timeZone} 24hr)` : '';
  return (
    <div className="summary-field-v-f-date-picker">
      <p className="field-title">
        {fieldTitle}
      </p>
      <p className="field-value">
        <span>{displayDate}</span>
        <span>{displayTime}</span>
      </p>
    </div>
  );
});

SummaryVFDatePicker.propTypes = {
  fieldData: summarySummaryVFDatePickerFieldData,
  selectedNetwork: PropTypes.string,
};

export { SummaryVFDatePicker };

